<h1 mat-dialog-title>{{ 'detailed_processing.insign.dialog.title.email' | translate }}</h1>

<div mat-dialog-content>

    <div class="row no-gutters">
        <div class="col-sm-12">
            <email-chips #to_chips
                         [label]="data.trans.insign_email_to"
                         [(addresses)]="data.insign_email_to"
                         [required]="isCaseDistributionJob"
                         [idPrefix]="idPrefix"
                         [idSuffix]="'insign_email_to'"
                         (validated)="to_addressInvalid = !$event">
            </email-chips>
        </div>
    </div>

    <div class="row no-gutters">
        <div class="col-sm-12">
            <mat-form-field class="full-width">
                <mat-label>{{ data.trans.insign_email_subject | translate }}</mat-label>
                <input type="text" matInput
                       id="{{idPrefix}}input_text.insign_email_subject"
                       [formControl]="insign_email_subject"
                       [required]="isCaseDistributionJob">
                <mat-error>{{ 'detailed_processing.distribution.error.insign_email_subject_required' | translate }}</mat-error>
            </mat-form-field>
        </div>
    </div>

    <div class="row no-gutters">
        <div class="col-sm-12">

            <div class="smp-title-small mb-2" [ngClass]="{ 'has-error': emailBodyHasError }">{{ data.trans.insign_email_body_before_link | translate }}
                <span *ngIf="isCaseDistributionJob && !data.insign_email_body_after_link"> *</span>
            </div>

            <smp-ck-editor [(bananaBox)]="data.insign_email_body_before_link"
                           (bananaBoxChange)="updateTextAreaValidation()"
                           [idPrefix]="idPrefix"
                           [idSuffix]="'insign_email_body_before_link'"
                           [disabled]="!!disabled">
            </smp-ck-editor>

        </div>
    </div>

    <div class="row no-gutters">
        <div class="col-sm-12">

            <div class="smp-title-small mt-4 mb-2" [ngClass]="{ 'has-error': emailBodyHasError }">{{ data.trans.insign_email_body_after_link | translate }}
                <span *ngIf="isCaseDistributionJob && !data.insign_email_body_before_link"> *</span>
            </div>

            <smp-ck-editor [(bananaBox)]="data.insign_email_body_after_link"
                           (bananaBoxChange)="updateTextAreaValidation()"
                           [idPrefix]="idPrefix"
                           [idSuffix]="'insign_email_body_after_link'"
                           [disabled]="!!disabled">
            </smp-ck-editor>

        </div>
    </div>

</div>

<div mat-dialog-actions align="center">

    <div class="col-sm-6 no-gutters pl-0">
        <button mat-stroked-button color="primary" id="{{idPrefix}}.btn.cancel" class="full-width" (click)="close()">{{ 'common.btn.cancel' | translate }}</button>
    </div>

    <div class="col-sm-6 no-gutters pr-0">
        <button mat-raised-button id="{{idPrefix}}.btn.accept" class="full-width" color="accent" (click)="accept()" [disabled]="!saveBtnEnabled">{{ 'common.btn.ok' | translate }}</button>
    </div>

</div>
